import { useReveal } from '../hooks/useReveal';
import MaterialIcon from './MaterialIcon';
import IdeCodePanel from './code/IdeCodePanel';

export default function Philosophy() {
  const [ref, visible] = useReveal();

  return (
    <section id="philosophy" className="ca-section" ref={ref} data-analytics-section="philosophy">
      <div className="ca-container">
        <div className={`ca-split ca-reveal ${visible ? 'ca-reveal--visible' : ''}`}>
          <div className="ca-split__main">
            <p className="ca-eyebrow">Why CrimsonArc Technologies</p>
            <h2 className="ca-section-title">Light after the hardest hour</h2>
            <p className="ca-prose">
              CrimsonArc Technologies was born from a simple image: a crimson arc across the sky after dusk—a
              breakthrough after struggle, warmth after isolation. We carry that into how we build:
              software as an arc from challenge to solution, from uncertainty to empowerment.
            </p>
          </div>
          <div className="ca-pillars">
            <article className="ca-pillar">
              <div className="ca-pillar__icon">
                <MaterialIcon name="local_fire_department" variant="glow" />
              </div>
              <h3 className="ca-pillar__title">Crimson</h3>
              <p className="ca-pillar__body">
                Courage, heart, and intensity—the passion behind late nights, bold bets, and
                products that refuse to be forgettable.
              </p>
            </article>
            <article className="ca-pillar">
              <div className="ca-pillar__icon">
                <MaterialIcon name="trending_up" variant="drift" />
              </div>
              <h3 className="ca-pillar__title">Arc</h3>
              <p className="ca-pillar__body">
                The curve between people and progress—bridging problems and outcomes with purposeful
                design and resilient engineering.
              </p>
            </article>
          </div>
        </div>

        <IdeCodePanel
          variant="design"
          caption="Design systems live in code—tokens, typography, and motion stay consistent from Figma to production."
          flip
        />
      </div>
    </section>
  );
}
